import script from "./metricasLocal.vue?vue&type=script&setup=true&lang=js"
export * from "./metricasLocal.vue?vue&type=script&setup=true&lang=js"

import "./metricasLocal.vue?vue&type=style&index=0&id=5424b29a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5424b29a"]])

export default __exports__